// source: pbtypes/gen/scan_planner/expanded_polygon_prism.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_planner_polygon_prism_pb = require('../../../pbtypes/gen/scan_planner/polygon_prism_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_polygon_prism_pb);
goog.exportSymbol('proto.scan_planner.ExpandedPolygonPrism', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.ExpandedPolygonPrism = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.ExpandedPolygonPrism, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.ExpandedPolygonPrism.displayName = 'proto.scan_planner.ExpandedPolygonPrism';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.ExpandedPolygonPrism.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.ExpandedPolygonPrism} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ExpandedPolygonPrism.toObject = function(includeInstance, msg) {
  var f, obj = {
polygonPrism: (f = msg.getPolygonPrism()) && pbtypes_gen_scan_planner_polygon_prism_pb.PolygonPrism.toObject(includeInstance, f),
lateralDistance: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.ExpandedPolygonPrism}
 */
proto.scan_planner.ExpandedPolygonPrism.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.ExpandedPolygonPrism;
  return proto.scan_planner.ExpandedPolygonPrism.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.ExpandedPolygonPrism} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.ExpandedPolygonPrism}
 */
proto.scan_planner.ExpandedPolygonPrism.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_scan_planner_polygon_prism_pb.PolygonPrism;
      reader.readMessage(value,pbtypes_gen_scan_planner_polygon_prism_pb.PolygonPrism.deserializeBinaryFromReader);
      msg.setPolygonPrism(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLateralDistance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.ExpandedPolygonPrism.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.ExpandedPolygonPrism} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.ExpandedPolygonPrism.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolygonPrism();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_scan_planner_polygon_prism_pb.PolygonPrism.serializeBinaryToWriter
    );
  }
  f = message.getLateralDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
};


/**
 * optional PolygonPrism polygon_prism = 1;
 * @return {?proto.scan_planner.PolygonPrism}
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.getPolygonPrism = function() {
  return /** @type{?proto.scan_planner.PolygonPrism} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_planner_polygon_prism_pb.PolygonPrism, 1));
};


/**
 * @param {?proto.scan_planner.PolygonPrism|undefined} value
 * @return {!proto.scan_planner.ExpandedPolygonPrism} returns this
*/
proto.scan_planner.ExpandedPolygonPrism.prototype.setPolygonPrism = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.ExpandedPolygonPrism} returns this
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.clearPolygonPrism = function() {
  return this.setPolygonPrism(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.hasPolygonPrism = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float lateral_distance = 8;
 * @return {number}
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.getLateralDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.ExpandedPolygonPrism} returns this
 */
proto.scan_planner.ExpandedPolygonPrism.prototype.setLateralDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.scan_planner);
